import { lazy } from 'react'

export const ImprovementsV1 = lazy(() => import('./ImprovementsV1'))
